import React from 'react';
import PropTypes from 'prop-types';
import LoadingCard from 'components/loading/LoadingCard';
import PointsOfInterestShow from './PointsOfInterestShow';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import { connect } from 'react-redux';
import { fetchPointOfInterest } from 'store/actions/pointsofinterest/fetchPointsOfInterest';
import { updatePointOfInterest } from 'store/actions/pointsofinterest/updatePointsOfInterest';
import { isArray, isObject, pick } from 'lodash';

class PointsOfInterestShowContainer extends React.Component {

    /**
     * Define the systemLanguage and put it on the top of the array.
     *
     * @param {Array} languages
     * @param {string} systemLanguage
     */
    reorderLanguagues(languages, systemLanguage) {
        const index = languages.indexOf(systemLanguage);

        if (~index) {
            languages.splice(index, 1);
            languages.unshift(systemLanguage);
        } else {
            languages.unshift(systemLanguage);
        }

        return languages;
    }

    handleAdd = (value, source) => {
        const { data } = this.props;

        const entity = data[source] || [];

        this.updatePointOfInterest({
            [source]: [
                ...entity,
                value,
            ],
        });
    }

    handleRemove = (value, source) => {
        const { data } = this.props;

        const updatedValue = data[source];

        if (isArray(updatedValue)) {
            updatedValue.splice(updatedValue.indexOf(value), 1);
        } else if (isObject(updatedValue)) {
            delete updatedValue[value];
        }

        this.updatePointOfInterest({
            [source]: updatedValue,
        });
    }

    updatePointOfInterest = (updatedValues) => {
        const { data, id, updatePointOfInterest } = this.props;

        const formValues = {};

        formValues.base = pick({
            ...data,
            ...updatedValues,
        }, [
            'address',
            'promoted_products',
            'type',
        ]);

        return new Promise((resolve) => {
            updatePointOfInterest({
                id,
                formValues,
                onSuccess: resolve,
                onError: resolve,
            });
        });
    }

    render() {
        const {
            data,
            id,
            localisation,
            localisationTypes,
            resourceFetchFailed,
            resourceFetchLoading,
        } = this.props;

        const {
            supported,
            system,
        } = this.context.config.language;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        if (!data) {
            return null;
        }

        return (
            <PointsOfInterestShow
                data={ data }
                id={ id }
                localisation={ localisation }
                supportedLanguages={ this.reorderLanguagues(supported, system) }
                handleAdd={ (value, source) => {
                    this.handleAdd(value, source);
                } }
                handleRemove={ (product, source) => {
                    this.handleRemove(product, source);
                } }
                types={ localisationTypes }
            />
        );
    }
}

PointsOfInterestShowContainer.defaultProps = {
    localisationTypes: [
        'name',
        'description',
    ],
};

PointsOfInterestShowContainer.contextTypes = {
    config: PropTypes.object,
};

PointsOfInterestShowContainer.propTypes = {
    data: PropTypes.object,
    id: PropTypes.number,
    localisation: PropTypes.object,
    localisationTypes: PropTypes.array,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    updatePointOfInterest: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        id,
    } = props;

    return {
        localisation: state.pointsofinterest.localisation[id],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updatePointOfInterest: (payload) => {
            dispatch(updatePointOfInterest(payload));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    fetchResourceById({
        action: fetchPointOfInterest,
        resource: 'pointsofinterest',
    }),
);

export default enhance(PointsOfInterestShowContainer);



// WEBPACK FOOTER //
// ./src/pages/pointsofinterest/show/PointsOfInterestShowContainer.js